/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutAlignLeft = createReactComponent(
  "layout-align-left",
  "IconLayoutAlignLeft",
  [
    ["path", { d: "M4 4l0 16", key: "svg-0" }],
    [
      "path",
      {
        d: "M8 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconLayoutAlignLeft as default };
//# sourceMappingURL=IconLayoutAlignLeft.js.map
